import { Component } from '@theme/component';

class WonderPlay extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.bindPlay();
  }

  updatedCallback() {
    super.updatedCallback();
    this.bindPlay();
  }

  bindPlay() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.timers ??= new Set();
    const signal = this.controller.signal;
    this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    this.addEventListener('click', event => {
      const toy = event.target.closest('[data-toy]');
      if (!toy || toy.disabled || toy.classList.contains('is-playing')) return;
      this.dataset.interactions = String(Number(this.dataset.interactions || 0) + 1);
      toy.classList.add('is-playing');
      const status = this.querySelector('[data-play-status]');
      if (status) status.textContent = toy.dataset.toy === 'rocket' ? this.dataset.launchMessage : this.dataset.wishMessage;
      const timer = setTimeout(() => {
        toy.classList.remove('is-playing');
        this.timers.delete(timer);
      }, this.reducedMotion.matches ? 600 : 2200);
      this.timers.add(timer);
    }, { signal });
    this.hero = this.closest('.gw-hero');
    this.hero?.addEventListener('pointermove', event => {
      if (this.reducedMotion.matches || event.pointerType === 'touch') return;
      const bounds = this.hero.getBoundingClientRect();
      const x = ((event.clientX - bounds.left) / bounds.width - .5) * 16;
      const y = ((event.clientY - bounds.top) / bounds.height - .5) * 12;
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        this.style.setProperty('--play-x', `${x}px`);
        this.style.setProperty('--play-y', `${y}px`);
      });
    }, { signal, passive: true });
    this.hero?.addEventListener('pointerleave', () => {
      cancelAnimationFrame(this.frame);
      this.style.setProperty('--play-x', '0px');
      this.style.setProperty('--play-y', '0px');
    }, { signal, passive: true });
  }

  disconnectedCallback() {
    this.controller?.abort();
    cancelAnimationFrame(this.frame);
    this.timers?.forEach(clearTimeout);
    this.timers?.clear();
    super.disconnectedCallback();
  }
}

if (!customElements.get('wonder-play')) customElements.define('wonder-play', WonderPlay);
